import { UserProfile } from "../../interfaces/profile";
import { FetchUserProfileAction } from "../actions/profile.action";
import { ActionType } from "../action_types";

interface ProfileState {
  userProfile: null | UserProfile;
  error: null | string;
  fetching: boolean;
}

const initialState = {
  userProfile: null,
  error: null,
  fetching: false,
};

const userProfileReducer = (state = initialState, action: FetchUserProfileAction): ProfileState => {
  switch (action.type) {
    case ActionType.FETCH_USER_PROFILE:
      return {
        ...state,
        userProfile: action.payload.userProfile!,
        fetching: action.payload.fetching!,
      };
    case ActionType.FETCHING:
      return { ...state, fetching: action.payload.fetching! };
    case ActionType.SET_ERROR:
      return { ...state, error: action.payload.error!, fetching: false };
    default:
      return { ...state };
  }
};

export default userProfileReducer;
